<template>
  <div class="descriptionPage">
    <div v-show="show1">
      <description @enter="enter"
                   @goBack="goBack">
        <template v-slot:content>
          在使用此项业务之前，请务必仔细阅读以下内容：<br />
          1.如您使用本项业务，则表示您同意遵守《【WoYou工资】服务及免责说明》和《【WoYou工资】隐私政策》的所有条款；<br />
          2.【WoYou工资】平台已与广发银行达成战略合作，并已签订战略合作协议。<br />
          3.【WoYou工资】平台为银行提供信息发布和链接跳转的技术服务，实际业务内容均由银行提供。<br />
          4.通过本平台申请办理的企业账户，银行可指派专业团队上门提供填表、收取资料等服务，详情可在平台上提交开户申请后，银行致电回访时咨询；<br />
          5.银行需要完成反洗钱、企业身份识别及登记办理等流程，有一定的办理周期。业务提交成功后可以在平台上查询银行反馈的业务进程，或留意银行的电话或短信通知。<br />
          6.由于实际业务均由我司战略伙伴银行直接办理，服务过程中可能出现的任何纠纷或风险请与银行联系，我平台不对相关具体服务内容承担责任。<br />
        </template>
        <template v-slot:btn>
          <el-button type="primary"
                     size="medium"
                     @click="enter">确 认</el-button>
        </template>
      </description>
      <el-dialog title="确认企业信息"
                 :visible.sync="enterVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="450px"
                 center
                 @close="resetForm">
        <el-form ref="companyform"
                 :model="form"
                 :rules="rules"
                 label-width="145px"
                 size="small"
                 v-enterToNext="true">
          <el-form-item label="企业名称"
                        prop="companyName">
            <el-input v-model="form.companyName"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码"
                        prop="creditCode">
            <el-input v-model="form.creditCode"> </el-input>
          </el-form-item>
          <el-form-item label="企业所在地"
                        prop="address">
            <el-input v-model="form.address"> </el-input>
          </el-form-item>
          <el-form-item label="企业联系人"
                        prop="contactName">
            <el-input v-model="form.contactName"> </el-input>
          </el-form-item>
          <el-form-item label="手机号码"
                        prop="contactPhone">
            <el-input v-model="form.contactPhone"
                      maxlength="11"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="(enterVisible = false), resetForm">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="confirm('companyform')">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提示"
                 :visible.sync="tipVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px"
                 center
                 @close="resetForm">
        表单信息将发送给您选定的银行，以方便银行为您提供服务！确认发送公户开立申请吗？
        <span style="text-decoration: underline; cursor: pointer; color: #409eff"
              @click="nav">点击预览推荐信</span>
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="tipVisible = false">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="send()">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <transition name="el-zoom-in-bottom">
      <CardList v-if="show2"
                @noteCard="noteCard" />
    </transition>
  </div>
</template>

<script>
import CardList from "./CardList";
import description from "@/components/description";

export default {
  components: {
    CardList,
    description,
  },
  props: {
    bankInfoList: Array,
  },
  data () {
    let validatecreditCode = (rule, value, callback) => {
      //使用正则表达式进行统一社会信用代码
      if (
        !/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(
          value
        )
      ) {
        callback(new Error("统一社会信用代码不正确"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      form: {},
      rules: {
        contactName: [
          { required: true, message: "请输入企业联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入企业手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请选择企业所在地", trigger: "blur" },
        ],
        creditCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          { validator: validatecreditCode, trigger: "blur" },
        ],
      },
      submitLoading: false,
      enterVisible: false,
      tipVisible: false,
      detail: "",
      show1: true,
      show2: false,
      mydata: "",
      userInfo: {},
    };
  },
  created () {
    this.CompanyDetail();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    goBack () {
      this.$parent.show1 = true;
      this.$parent.show3 = false;
    },
    nav () {
      this.form.bankName = this.bankInfoList[0].bankName;
      let detail = JSON.stringify(this.form);
      if (this.bankInfoList[0].bankUniqueFlag == "CGB") {
        let href = "/recommendation?detail=" + detail;
        window.open(href, "_blank");
      } else {
        let href = "/recommendation-rayqee?detail=" + detail;
        window.open(href, "_blank");
      }
      // this.$router.push("/recommendation");
    },
    noteCard (flag) {
      if (flag == true) {
        this.$parent.show1 = true;
        this.$parent.show3 = false;
      } else {
        this.show1 = !this.show1;
        this.show2 = !this.show2;
      }
    },
    send () {
      this.submitLoading = true;

      let sendData = {
        companyId: this.detail.id,
        companyName: this.form.companyName,
        creditCode: this.form.creditCode,
        address: this.form.address,
        contactName: this.form.contactName,
        contactPhone: this.form.contactPhone,
        bankId: this.bankInfoList[0].bankId,
        bankName: this.bankInfoList[0].bankName,
        bankUniqueFlag: this.bankInfoList[0].bankUniqueFlag,
        sendTo: this.bankInfoList[0].sendTo,
        sendCC: this.bankInfoList[0].sendCC,
        emailSubject:
          this.bankInfoList[0].bankUniqueFla == "CGB"
            ? "易奇推荐函"
            : "瑞启推荐函",
        emailBodyIsHtml: true,
        createUserAccount: this.userInfo.account,
        createUserTel: this.userInfo.tel,
      };
      this.$api.email.SentEmailToBankByNetCoreLogic(sendData).then((res) => {
        this.submitLoading = false;

        if (res.error === false) {
          this.$message.success("发送成功！");
          this.show1 = !this.show1;
          this.show2 = !this.show2;
          this.tipVisible = false;
          this.enterVisible = false;

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    CompanyDetail () {
      this.$api.user.CompanyDetail().then((res) => {
        if (res.code === 0) {
          this.detail = res.data;
          window.localStorage.setItem(
            "CompanyDetail",
            JSON.stringify(res.data)
          );
          this.$store.commit("change", res.data);

        }
      });
    },
    resetForm () { },
    enter () {
      this.enterVisible = true;
      this.$set(this.form, "companyName", this.detail.companyName);
      this.$set(this.form, "address", this.detail.address);
      this.$set(this.form, "contactName", this.detail.contactName);
      this.$set(this.form, "contactPhone", this.detail.contactPhone);
      this.$set(this.form, "creditCode", this.detail.creditCode);
    },

    drawermonstransVisibleClose () {
      this.$emit("close");
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.tipVisible = true;
        }
      });
    },
  },
  watch: {},
};
</script>
<style lang="less">
.descriptionPage .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style lang="less" scoped>
.descriptionPage {
  .title {
    text-align: center;
    font-size: 20px;
  }
  .content {
    padding: 20px 300px;
    line-height: 25px;
  }
  .btnBox {
    position: fixed;
    bottom: 60px;
    left: calc(50% - 82px);
    text-align: center;
    .btn {
      margin-top: 10px;
    }
  }
}
</style>